// extracted by mini-css-extract-plugin
export var avatarContainer = "_7f-0";
export var avatarTypingWave = "_7f-i";
export var gray = "_7f-f";
export var green = "_7f-c";
export var icon = "_7f-9";
export var image = "_7f-1";
export var lg = "_7f-6";
export var md = "_7f-5";
export var presenceDot = "_7f-b";
export var red = "_7f-d";
export var sm = "_7f-4";
export var status = "_7f-a";
export var typingDot = "_7f-h";
export var typingPill = "_7f-g";
export var xl = "_7f-7";
export var xs = "_7f-3";
export var xxl = "_7f-8";
export var xxs = "_7f-2";
export var yellow = "_7f-e";